module.exports = __webpack_public_path__ + "static/media/bus.84f45605.svg";